// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/Handlers/SetFieldValue";
import { RecommendedProductRequestFormContext } from "@store/Library/Widgets/RecommendedProductRequest/RecommendedProductRequestForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isRequired = "isRequired",
    isDisabled = "isDisabled",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.isDisabled]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
    email: state.greif.components.recommendedProductRequestForm.fieldValues["email"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface EmailStyles {
    emailTextField?: TextFieldPresentationProps;
}

export const emailStyles: EmailStyles = {};

const styles = emailStyles;
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const Email: FC<Props> = ({ fields, session, email, setFieldValue }) => {
    const { isRequired, isDisabled } = fields;
    const recommendedProductRequestFormContext = useContext(RecommendedProductRequestFormContext);
    const [emailErrorMessage, setEmailErrorMessage] = useState<string>("");

    const emailLabel = translate("Email");

    useEffect(() => {
        if (session) {
            setFieldValue({ key: "email", value: session.email });
        }
    }, [session]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.email = validateEmail;
        if (typeof email !== "undefined") {
            validateEmail();
        }
    }, [email]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.email = validateEmail;
    }, [isRequired]);

    const validateEmail = () => {
        const errorMessage =
            isRequired && !email
                ? siteMessage("Field_Required", emailLabel).toString()
                : !email || emailRegexp.test(String(email))
                  ? ""
                  : (siteMessage("ContactUsForm_EmailIsInvalidErrorMessage") as string);
        setEmailErrorMessage(errorMessage);
        return !errorMessage;
    };

    const emailChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "email", value: event.target.value });
    };

    return (
        <TextField
            {...styles.emailTextField}
            label={emailLabel}
            value={email || ""}
            onChange={emailChangeHandler}
            required={isRequired}
            type="email"
            error={emailErrorMessage}
            {...styles.emailTextField}
            disabled={isDisabled}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(Email),
    definition: {
        displayName: "Email",
        group: constants.widgetGroup.recommendedProductRequest,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.recommendedProductRequest],
        fieldDefinitions: [
            {
                name: fields.isDisabled,
                displayName: "Disabled?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
